export enum PaymentMethodEnum {
  CARD = "card_delivery",
  CASH = "cash_delivery",
  PREPAID = "card_online",
  APPLE_PAY = "apple_pay",
  TAB = "add_to_tab",
}
